import { t } from 'i18next';

export enum UserOrigin {
  LOCAL = 'LOCAL',
  OPENID = 'OPENID',
  WEB_ACCOUNT = 'WEB_ACCOUNT',
}

export const getUserOriginLabel = (origin: UserOrigin): string => {
  switch (origin) {
    case UserOrigin.LOCAL:
      return t('userOrigins.local');
    case UserOrigin.OPENID:
      return t('userOrigins.openId');
    case UserOrigin.WEB_ACCOUNT:
      return t('userOrigins.webAccount');
  }
};
